import React from "react";
import { Avatar, Typography, Grid } from "antd";
import { useSelector } from "react-redux";
import { selectAuthInfo } from "../../Auth/authSelectors";

const { Title, Text } = Typography;

export default function DashboardHeader(){

const auth = useSelector(selectAuthInfo);

const name = auth?.userInfo?.name || "User";
const first = name.charAt(0).toUpperCase();


const screens = Grid.useBreakpoint();

return(

<div className="dashboard-header">

<div>
<Title level={screens.xs ? 4 : 3}>HR & Payroll Dashboard</Title>
{/* <Text type="secondary">
Welcome back, {name}
</Text> */}
</div>

{/* <Avatar
size={48}
style={{
background:"#1976d2"
}}
>
{first}
</Avatar> */}

</div>

);

}